var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24694 8.29043C3.24694 5.52521 5.48859 3.28356 8.2538 3.28356C10.7605 3.28356 12.837 5.12567 13.2033 7.53002C13.0193 7.55578 12.8355 7.58544 12.6521 7.61903L12.5442 7.63879C10.4265 8.02668 9.1559 10.2144 9.86832 12.246L10.1121 12.9413C9.53807 13.1709 8.91128 13.2973 8.2538 13.2973C5.48859 13.2973 3.24694 11.0556 3.24694 8.29043ZM10.6765 14.5509C9.92453 14.8421 9.10726 15.0017 8.2538 15.0017C4.54724 15.0017 1.54248 11.997 1.54248 8.29043C1.54248 4.58386 4.54724 1.5791 8.2538 1.5791C11.6594 1.5791 14.4725 4.11572 14.9069 7.40266C17.0643 7.38073 19.2066 7.88547 21.1425 8.88828C22.9806 9.8404 23.5667 12.1891 22.3913 13.8931L17.8016 20.5472C16.4167 22.5549 13.3385 22.1422 12.5314 19.8406L10.6765 14.5509ZM12.9592 9.2956C15.4801 8.83387 18.0829 9.22298 20.3586 10.4017C21.2854 10.8818 21.5809 12.0661 20.9882 12.9253L16.3985 19.5794C15.805 20.4399 14.4858 20.263 14.1399 19.2766L11.4768 11.682C11.1108 10.6384 11.7635 9.51461 12.8513 9.31536L12.9592 9.2956Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.0e9ce7442afdbf3898b7327a508a3c6c.svg";
export { ForwardRef as ReactComponent };